module.exports = __webpack_public_path__ + "static/media/link.4330f300.svg";